(() => {
  if (window.__loxstarJournalTrackingReady) return;
  window.__loxstarJournalTrackingReady = true;

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-lj-product-cta] a') : null;
    if (!target) return;

    const cta = target.closest('[data-lj-product-cta]');
    if (cta.dataset.ljPreview === 'true') return;

    const eventData = {
      article_id: cta.dataset.articleId || '',
      article_handle: cta.dataset.articleHandle || '',
      product_id: cta.dataset.productId || '',
      product_handle: cta.dataset.productHandle || '',
      preview: cta.dataset.ljPreview === 'true'
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'journal_product_clickthrough', eventData);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'journal_product_clickthrough', ...eventData });
    }
  });
})();

(() => {
  const initialise = () => {
    document.querySelectorAll('.loxstar-journal__article-layout').forEach((layout) => {
      const headings = [...layout.querySelectorAll('.loxstar-journal__content > h2, .loxstar-journal__content > h3')];
      const used = new Set([...document.querySelectorAll('[id]')].map((node) => node.id));
      headings.forEach((heading, index) => {
        if (heading.id) return;
        const base = heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let id = base;
        let count = 1;
        while (used.has(id)) id = `${base}-${++count}`;
        heading.id = id;
        used.add(id);
      });
      layout.querySelectorAll('[data-lj-toc]').forEach((toc) => {
        if (toc.dataset.ljReady) return;
        toc.dataset.ljReady = 'true';
        if (!headings.length) { toc.hidden = true; return; }
        const list = document.createElement('ol');
        headings.forEach((heading) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent;
          link.addEventListener('click', () => {
            const details = toc.closest('details');
            if (details) details.open = false;
          });
          if (heading.tagName === 'H3') item.className = 'lj-toc-sub';
          item.append(link); list.append(item);
        });
        if (toc.tagName === 'ASIDE') {
          const inner = document.createElement('div'); inner.className = 'loxstar-journal__toc-inner';
          const label = document.createElement('h2'); label.textContent = 'In this article';
          inner.append(label, list); toc.append(inner);
        } else toc.append(list);
      });
    });
    // Phone tables: label each cell with its column heading so rows can stack as cards (CSS below 640 px).
    document.querySelectorAll('.loxstar-journal__content .lx-table').forEach((table) => {
      const heads = [...table.querySelectorAll('thead th')].map((th) => th.textContent.trim());
      if (!heads.length || table.classList.contains('lx-table--stackable')) return;
      table.querySelectorAll('tbody tr').forEach((row) => {
        [...row.children].forEach((cell, index) => { if (heads[index]) cell.setAttribute('data-label', heads[index]); });
      });
      table.classList.add('lx-table--stackable');
      const wrap = table.closest('.lx-table-wrap');
      const hint = wrap && wrap.previousElementSibling;
      if (hint && hint.classList.contains('lx-table-hint')) hint.classList.add('lx-table-hint--stackable');
    });
    // Keep hyphenated compound names (GHK-Cu, AHK-Cu) on one line in headings and table cells.
    const compound = /\b(?:[A-Z]{2,5}-Cu|[a-z]{3,10}-[A-Z]{2,5})\b/g;
    const hasCompound = /\b(?:[A-Z]{2,5}-Cu|[a-z]{3,10}-[A-Z]{2,5})\b/;
    document.querySelectorAll('.loxstar-journal__content :is(h2, h3, th, td), .loxstar-journal__toc-rail a, .loxstar-journal__toc-mobile a').forEach((node) => {
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      const texts = [];
      while (walker.nextNode()) if (hasCompound.test(walker.currentNode.nodeValue)) texts.push(walker.currentNode);
      texts.forEach((text) => {
        compound.lastIndex = 0;
        const fragment = document.createDocumentFragment();
        let last = 0;
        text.nodeValue.replace(compound, (match, offset) => {
          fragment.append(text.nodeValue.slice(last, offset));
          const span = document.createElement('span'); span.className = 'lx-nowrap'; span.textContent = match;
          fragment.append(span); last = offset + match.length; return match;
        });
        fragment.append(text.nodeValue.slice(last));
        text.replaceWith(fragment);
      });
      compound.lastIndex = 0;
    });
    const updateOffset = () => {
      const header = document.querySelector('.section-header');
      const height = header ? header.getBoundingClientRect().height : 96;
      document.querySelectorAll('.loxstar-journal').forEach((journal) => journal.style.setProperty('--lj-header-offset', `${Math.ceil(height)}px`));
    };
    updateOffset();
    window.addEventListener('resize', updateOffset, { passive: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
